var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "metadata list-inline" }, [
    _c(
      "li",
      { staticClass: "list-inline-item" },
      [
        _c("i", { staticClass: "fa fa-user-alt" }),
        _vm._v(" "),
        _c("vue-user-name", { attrs: { user: _vm.guide.user } }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { staticClass: "list-inline-item" },
      [
        _c("i", { staticClass: "far fa-calendar-alt" }),
        _vm._v(" "),
        _c("vue-timeago", { attrs: { datetime: _vm.guide.created_at } }),
      ],
      1
    ),
    _vm._v(" "),
    _c("li", { staticClass: "list-inline-item" }, [
      _c("i", { staticClass: "far fa-comments" }),
      _vm._v(
        " " +
          _vm._s(_vm.guide.comments_count) +
          " " +
          _vm._s(
            _vm._f("declination")(_vm.guide.comments_count, [
              "komentarz",
              "komentarze",
              "komentarzy",
            ])
          ) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "list-inline-item" }, [
      _c("i", { staticClass: "far fa-eye" }),
      _vm._v(
        "\n\n    " +
          _vm._s(_vm.guide.views) +
          " " +
          _vm._s(
            _vm._f("declination")(_vm.guide.views, [
              "wyświetlenie",
              "wyświetlenia",
              "wyświetleń",
            ])
          ) +
          "\n  "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }